import { Avatar, Body } from 'copilot-design-system';
import { useContext } from 'react';

import { FlagsContext } from 'src/context/flagsContext';
import { InvoiceDraftDetailTypes } from 'src/features/assistant/action-item/BillingDraftWidget';
import { StripeCurrencyFormatterAdapter } from 'src/legacy/components/Formatters';
import { LineItem } from 'src/services/api/invoicesApi';
import { BILLING_PERIODS } from 'src/services/api/productsApi';

export const BillingDraftItems = ({
  billingDetails,
  avatarMap,
}: {
  billingDetails: InvoiceDraftDetailTypes;
  avatarMap: Record<string, string>;
}) => {
  const { EnableLegacyAvatarColorMapping } = useContext(FlagsContext);
  const { lineItems, currency, interval } = billingDetails;

  const billingInterval = BILLING_PERIODS.find(
    (i) => i.value === interval,
  )?.label.toLocaleLowerCase();

  return (
    <div className="flex gap-3 flex-col">
      {lineItems.map((lineItem: LineItem) => (
        <div key={lineItem.id} className="flex gap-4">
          <div className="flex">
            <Avatar
              src={avatarMap[lineItem.productId || '']}
              alt={lineItem.description || ''}
              size="lg"
              variant="rounded"
              text={lineItem.description?.at(0)?.toLocaleUpperCase()}
              useNewColors={EnableLegacyAvatarColorMapping}
            />
          </div>
          <div className="flex flex-col justify-between w-full">
            <div className="flex justify-between">
              <Body size="sm">{lineItem.description || ''}</Body>
              <Body size="sm">
                {StripeCurrencyFormatterAdapter({
                  value: Number(lineItem.amount) * Number(lineItem.quantity),
                  currency,
                })}
              </Body>
            </div>
            <div className="flex justify-between items-center">
              <Body className="text-gray-small text-[10px]">
                {`Qty: ${lineItem.quantity}${
                  interval ? `, Billed ${billingInterval}` : ''
                }`}
              </Body>

              {Number(lineItem.quantity) > 1 && (
                <Body className="text-gray-small text-[10px]">
                  {`${StripeCurrencyFormatterAdapter({
                    value: Number(lineItem.amount),
                    currency,
                  })} each`}
                </Body>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
